export default __webpack_public_path__ + "static/media/Comparative_effectiveness.0d73aeff.png";